export default __webpack_public_path__ + "static/media/RizadaOpaco.7e02edaa.jpg";